import api from "../config/api";

// Service for Course and its hierarchical children: areas, subareas, specialties

const store = (data: any) => {
  return api.post("/course", data);
};

const getAll = (page = 1, paginate = 0, query?: string) => {
  const qs = query && query.indexOf("=") > -1 ? `&${query}` : (query ? `&filter=${encodeURIComponent(query)}` : "");
  return api.get(`/course?page=${page}&paginate=${paginate}${qs}`);
};

const get = (id: number) => {
  return api.get(`/course/${id}`);
};

const update = (id: any, data: any) => {
  return api.put(`/course/${id}`, data);
};

const remove = (id: any) => {
  return api.delete(`/course/${id}`);
};

// Areas (child of course)
const getAreas = (courseId: number) => {
  return api.get(`/course/${courseId}/areas`);
};

const storeArea = (courseId: number, data: any) => {
  return api.post(`/course/${courseId}/areas`, data);
};

const updateArea = (id: any, data: any) => {
  return api.put(`/course/area/${id}`, data);
};

const removeArea = (id: any) => {
  return api.delete(`/course/area/${id}`);
};

// Subareas (child of area)
const getSubareas = (areaId: number) => {
  return api.get(`/course/areas/${areaId}/subareas`);
};

const storeSubarea = (areaId: number, data: any) => {
  return api.post(`/course/areas/${areaId}/subareas`, data);
};

const updateSubarea = (id: any, data: any) => {
  return api.put(`/course/subarea/${id}`, data);
};

const removeSubarea = (id: any) => {
  return api.delete(`/course/subarea/${id}`);
};

// Specialties (child of subarea)
const getSpecialties = (subAreaId: number) => {
  return api.get(`/course/subareas/${subAreaId}/specialties`);
};

const storeSpecialty = (subAreaId: number, data: any) => {
  return api.post(`/course/subareas/${subAreaId}/specialties`, data);
};

const updateSpecialty = (id: any, data: any) => {
  return api.put(`/course/specialty/${id}`, data);
};

const removeSpecialty = (id: any) => {
  return api.delete(`/course/specialty/${id}`);
};

const CourseService = {
  store,
  getAll,
  get,
  update,
  remove,

  getAreas,
  storeArea,
  updateArea,
  removeArea,

  getSubareas,
  storeSubarea,
  updateSubarea,
  removeSubarea,

  getSpecialties,
  storeSpecialty,
  updateSpecialty,
  removeSpecialty,
};

export default CourseService;
